import { Directive, OnDestroy, OnInit, Renderer2 } from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import {
	AutomataBreadcrumbService,
	Breadcrumb
} from "@shared/services/automata-breadcrumb.service";

@Directive({
	selector: "[appAutomataBreadcrumb]"
})
export class AutomataBreadcrumbDirective implements OnInit, OnDestroy {
	private destroy$ = new Subject<void>();

	constructor(
		private renderer: Renderer2,
		private automataBreadcrumbService: AutomataBreadcrumbService
	) {}

	ngOnInit() {
		this.automataBreadcrumbService.breadcrumbs$
			.pipe(takeUntil(this.destroy$))
			.subscribe((breadcrumbs: Breadcrumb[]) => {
				if (breadcrumbs.length) {
					this._checkAndInsertBreadcrumb(breadcrumbs);
				}
			});
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}

	private _checkAndInsertBreadcrumb(breadcrumbs: Breadcrumb[]) {
		requestAnimationFrame(() => {
			const specificSelector =
				"atlas-screen > atlas-page > atlas-page-header";

			const atlasPageHeader = this._getAtlasPageHeader(specificSelector);

			if (atlasPageHeader) {
				const hasBreadcrumb = this._hasBreadcrumb(specificSelector);

				if (!hasBreadcrumb) {
					this.renderer.addClass(atlasPageHeader, "has-breadcrumb");
					this.renderer.setProperty(
						this._getAtlasBreadcrumbContainer(),
						"innerHTML",
						this._generateBreadcrumb(breadcrumbs)
					);
				}
			}
		});
	}

	private _generateBreadcrumb(breadcrumbs: Breadcrumb[]): string {
		return `<atlas-breadcrumb slot="breadcrumb">
    ${breadcrumbs
		.map(
			(breadcrumb) => `
          <atlas-breadcrumb-item
            text="${breadcrumb.label}"
            ${breadcrumb?.showBreadcrumbLink && breadcrumb?.url ? `href="${breadcrumb.url}"` : ""}
            ${breadcrumb?.icon ? `icon="${breadcrumb.icon}"` : ""}
          >
          </atlas-breadcrumb-item>
        `
		)
		.join("")}
  </atlas-breadcrumb>`;
	}

	private _hasBreadcrumb(specificSelector: string): Element | null {
		return document.querySelector(
			`${specificSelector} > atlas-breadcrumb > atlas-breadcrumb-item:nth-child(1)`
		);
	}

	private _getAtlasBreadcrumbContainer(): Element | null | undefined {
		return document
			?.querySelector?.("atlas-screen > atlas-page > atlas-page-header")
			?.shadowRoot?.querySelector?.("div > div.page-breadcrumb > slot");
	}

	private _getAtlasPageHeader(
		specificSelector: string
	): Element | null | undefined {
		return document
			.querySelector(specificSelector)
			?.shadowRoot?.querySelector("div");
	}
}
